import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function MnemonicMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="mnemonic" />

    </>
  );
}

export default MnemonicMathTopics;